import { createFileRoute } from "@tanstack/react-router";
import { buildBreadcrumbs } from "@/components/SchemaJsonLd";
import { PageHero } from "@/components/PageHero";
import { MultiStepQuoteForm } from "@/components/MultiStepQuoteForm";
import { SectionHeading } from "@/components/SectionHeading";
import { SITE } from "@/lib/site";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import grindingImg from "@/assets/diamond-grinding.jpg";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact MLC Epoxy Floors | Calgary AB Epoxy Floors" },
      { name: "description", content: "Contact MLC Epoxy Floors in Airdrie, AB. Call (703) 555-0143 or request a free quote online. Serving all of Calgary and surrounding areas." },
      { property: "og:title", content: "Contact | MLC Epoxy Floors" },
      { property: "og:description", content: "Reach the Calgary region's premier garage floor coating specialists." },
      { property: "og:url", content: "/contact" },
    ],
    links: [{ rel: "canonical", href: "/contact" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" },
        { name: "Contact", href: "/contact" },
      ])) },
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <>
      <PageHero eyebrow="Contact" title="Talk To The Calgary Region's Garage Floor Specialists" body="Call us, email us, or use the form — we typically respond within one business day." image={grindingImg} showCTA={false} />
      <section className="container-x py-20 grid gap-12 lg:grid-cols-2">
        <div className="space-y-6">
          <SectionHeading title="Get In Touch" />
          <div className="space-y-4 text-silver">
            <p className="flex items-start gap-3"><Phone className="h-5 w-5 text-copper mt-0.5" /><span><span className="block text-xs uppercase tracking-widest text-muted-foreground">Phone</span><a href={SITE.phoneHref} className="text-silver-light hover:text-copper text-lg">{SITE.phone}</a></span></p>
            <p className="flex items-start gap-3"><Mail className="h-5 w-5 text-copper mt-0.5" /><span><span className="block text-xs uppercase tracking-widest text-muted-foreground">Email</span><a href={`mailto:${SITE.email}`} className="text-silver-light hover:text-copper text-lg">{SITE.email}</a></span></p>
            <p className="flex items-start gap-3"><MapPin className="h-5 w-5 text-copper mt-0.5" /><span><span className="block text-xs uppercase tracking-widest text-muted-foreground">Headquarters</span><span className="text-silver-light text-lg">{SITE.address.street}<br />{SITE.address.city}, {SITE.address.region} {SITE.address.postal}</span></span></p>
            <p className="flex items-start gap-3"><Clock className="h-5 w-5 text-copper mt-0.5" /><span><span className="block text-xs uppercase tracking-widest text-muted-foreground">Hours</span><span className="text-silver-light text-lg">{SITE.hours}</span></span></p>
          </div>
          <div className="mt-6 rounded-sm overflow-hidden border border-border">
            <iframe
              title="MLC Epoxy Floors location"
              src="https://www.google.com/maps?q=260+South+Point+Pk+SW,+Airdrie,+AB+T4B+0X2&output=embed"
              width="100%"
              height="320"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
            />
          </div>
        </div>
        <div className="rounded-md border border-border bg-ivory p-7 md:p-8 shadow-2xl">
          <MultiStepQuoteForm />
        </div>
      </section>
    </>
  );
}
